/*
 * @Author: edvardchen
 * @Date:   2016-10-23 12:35:26
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-01-28 13:07:13
 */

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import * as urlHelper from '@tencent/qb-article-util/lib/urlHelper';
import Item from './ReactQbForShare/FeedItem'; // 分享框架页面单独抽离出来组件

import { FOCUS } from './imageType';
// import Item from './Item';

import Image from '../Image';
import Label from './Label';

import { supportArticleSingleWebview, redirect } from '../../utility';
import urlUtil from '../../utility/url';
import { contextTypes } from '../../HOCs/withRoute';

// import styles from './index.scss';

const numberOrString = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

const skipTypes = {
  EXTERNAL: 1, // 外链，用普通 webview 方式打开
};

// const MULTI_IMAGE_INDICATOR = 3;

export default class MediaArticle extends React.PureComponent {
  static propTypes = {
    ...Item.propsTypes,
    imageType: PropTypes.number,
    // title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    docId: numberOrString,
    tagId: numberOrString,
    tabId: numberOrString,
    ch: numberOrString, // 防止 ch=0 告警
    dataSrc: numberOrString,
    // thumbs: PropTypes.arrayOf(PropTypes.string),
    extenddata: PropTypes.string,
    commentUrl: PropTypes.string,
    commentNum: PropTypes.number,
    from: PropTypes.string,
    labels: PropTypes.arrayOf(PropTypes.shape(Label.propTypes)),
    // onClick: PropTypes.func,
  };

  static contextTypes = {
    ...contextTypes,
    ctridext: PropTypes.string,
  };

  @autobind
  onClick(event) {
    event.preventDefault();
    const {
      docId,
      url,
      tagId,
      tabId,
      ch,
      skip,
      // commentNum,
      // commentUrl,
      onClick,
      extenddata,
      pid,
      data_type,
    } = this.props;
    if (onClick) {
      if (onClick(event, this.props) === false) {
        // return false then cancele
        return;
      }
    }
    if (skipTypes.EXTERNAL === skip) {
      const urlObj = urlUtil.parse(url);

      // add ch into video url
      urlObj.query.ch = ch || this.context.currentChannel;
      const targeturl = urlUtil.format(urlObj);
      redirect(targeturl);
      return;
    }

    const single = supportArticleSingleWebview(_.get(window, 'browser.env.version'));
    const { ctridext } = this.context;
    const urlData = {
      pid,
      data_type,
      extenddata,
      ctridext,
      cityid: ctridext, // old way
      docId,
      url,
      tagId,
      tabId,
      ch: ch || this.context.currentChannel,
      business: 'coolread',
      clientWidth: window.innerWidth,
    };
    const qburl = urlHelper.buildArticleQBUrl({
      ...urlData,
      single,
    });
    redirect(qburl, urlHelper.buildArticleUrl(urlData));
  }

  render() {
    const { from, title, thumbs, commentNum, imageType } = this.props;

    const labels = [...(this.props.labels || [])];
    labels.forEach((item) => {
      let color;
      switch (item.colorType) {
        case 1:
          color = 'red';
          break;
        case 2:
          color = 'blue';
          break;
        default:
          break;
      }
      Object.assign(item, {
        color,
        withBorder: true,
      });
    });
    if (from) {
      labels.push({
        text: from,
        limit: true,
      });
    }
    if (commentNum) {
      labels.push({
        text: `${commentNum}评`,
      });
    }

    let content;
    if (imageType === FOCUS) {
      content = (
        <div onClick={this.onClick}>
          <Image src={thumbs[0]} initPadding={'48.6%'} />
          <Item {...{ title, labels }} />
        </div>
      );
    } else {
      content = <Item {...{ title, labels, thumbs }} onClick={this.onClick} />;
    }

    return content;
  }
}
